module.exports = __webpack_public_path__ + "img/example4.01779c29.jpg";